import { DataService } from './data.service';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppRoutingModule} from './app-routing.module';
import {SharedModule} from './shared/shared.module';
import {AccountModule} from './account/account.module';
import {DmsModule} from './dms/dms.module';
import {DmsRoutingModule} from './dms/dms-routing.module';
import {ESignatureModule} from './e-signature/e-signature.module';
import {ESignatureRoutingModule} from './e-signature/e-signature-routing.module';
import {EFormModule} from './e-form/e-form.module';
import {AppCommonModule} from './common/common.module';
import {AuthGuard} from './auth-guard.service';
import {IdexService} from './idex.service';
import {AppComponent} from './app.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {PrivacyComponent} from './shared/privacy/privacy.component';
import {TermOfUseComponent} from './shared/terms/terms.component';
import {FileSizePipe} from './shared/file-size.pipe';
import {NumeralPipe} from './shared/numeral.pipe';
import {AdminMenuComponent} from './admin/admin-menu/admin-menu.component';
import {AdminModule} from './admin/admin.module';
import {AdminRoutingModule} from './admin/admin-routing.module';
import {PdpaComponent} from './shared/pdpa/pdpa.component';
import {CanDeactivateGuard} from './candeactivate-guard.service';
import {MatLegacyPaginatorIntl as MatPaginatorIntl} from '@angular/material/legacy-paginator';
import {CustomMatPaginatorIntl} from './shared/CustomMatPaginatorIntl';
import { AccountRoutingModule } from './account/account-routing.module';
import {HttpClient} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import { app } from '../environments/version';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {getActiveLang} from './shared/lang';

export function HttpLoaderFactory(http: HttpClient) {
   return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + app.version);
}

/*
 * Load the active language before the app renders. The translate pipe returns an empty string
 * while its i18n file is still in flight, and mat-select is OnPush: a select that initialises
 * during that window latches an empty trigger label and never recovers. Failures are swallowed
 * so a missing/unreachable i18n file cannot block bootstrap.
 */
export function TranslationInitializerFactory(translate: TranslateService) {
   return () => {
      translate.setDefaultLang('en');
      return translate.use(getActiveLang()).toPromise().catch(() => undefined);
   };
}

@NgModule({
   imports: [
      BrowserModule,
      BrowserAnimationsModule,
      FormsModule,
      SharedModule,
      AccountModule,
      DmsModule,
      ESignatureModule,
      EFormModule,
      DmsRoutingModule,
      ESignatureRoutingModule,
      AdminRoutingModule,
      AppRoutingModule,
      AdminModule,,
      TranslateModule.forRoot({
         loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
         }
      }),
      AppCommonModule,
      AccountRoutingModule
   ],
   declarations: [
      AppComponent,
      DashboardComponent,
      PrivacyComponent,
      TermOfUseComponent,
      AdminMenuComponent,
      PdpaComponent
   ],
   providers: [
      {
         provide: APP_INITIALIZER,
         useFactory: TranslationInitializerFactory,
         deps: [TranslateService],
         multi: true
      },
      AuthGuard,
      IdexService,
      DataService,
      FileSizePipe,
      NumeralPipe,
      CanDeactivateGuard,
      {
         provide: MatPaginatorIntl,
         useClass: CustomMatPaginatorIntl,
      },
   ],
   bootstrap: [AppComponent]
})
export class AppModule {
}
